import { CardContent, Container } from '@mui/material'
import { ContainerProps } from '@mui/material/Container/Container'

export default function PageContent(props: ContainerProps) {
  return <Container component={CardContent} {...props}></Container>
}
